import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, projectname, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import LOADER from "../../assets/img/barakahhijama.gif";

function AdminList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();

  const [articles, setArticles] = useState([]);
  const [loading, setloading] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getArticles();
    // const interval = setInterval(() => {
    //   getArticles();
    // }, 30000);
    // return () => clearInterval(interval);
  }, []);

  const getArticles = () => {
    axios.get(URL_API + "auth/admin/get-admins").then((response) => {
      if (response.data.status === 200) {
        setArticles(response.data.admins);
        setloading(false)
      }
    });
  };

  const destroyArticle = (id) => {
    handleShow();

    axios.post(URL_API + `auth/admin/destroy-admin/${id}`).then((response) => {
      if (response.data.status === 200) {
        history.push("/admin/admins");
        toast.success("Admin Deleted Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        getArticles();
      }
    });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  {" "}
                  {projectname} | <i class="fa fa-home" aria-hidden="true"></i> |
                  All Admins
                </CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <Link to={`/admin/create/admin`}>
                  <strong>create Admin + </strong>
                </Link>
              </div>
              <CardBody>
                <Table responsive>
                  {loading == true ? (
                    <>
                      <div className="loader">
                        <img src={LOADER} />
                      </div>
                    </>
                  )
                    :
                    <>
                      <thead className="text-primary">
                        <tr>
                          <th>#</th>
                          <th>name</th>
                          <th>email</th>
                          <th style={{ textAlign: "center" }}>Permissions</th>
                          <th>Created At</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {articles.map(
                          (article, index) => {
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{article?.full_name}</td>
                                <td>{article?.email}</td>

                                <td>
                                  {article?.admin_permissions?.map((ap) => {
                                    return (
                                      <>
                                        <div
                                          style={{
                                            backgroundColor: "#a9d4e8",
                                            padding: "5px",
                                            borderRadius: "25px",
                                            margin: "3px",
                                            fontWeight: "600",
                                            textAlign: "center",
                                          }}
                                        >
                                          {ap?.name}
                                        </div>
                                      </>
                                    );
                                  })}
                                </td>
                                {/* <td width="30">
                                {article.description.substring(0, 50)}...
                              </td> */}

                                {/* <td>{article?.status}</td> */}

                                <td>
                                  {moment(article?.created_at).format(
                                    " DD MMMM,YYYY"
                                  )}
                                </td>
                                <td>
                                  {/* <a style={{color:"#77ac54"}} href={`article/detail/${article.id}`}>
                                  <i class="fas fa-eye fa-lg"></i>
                                </a> */}
                                  {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
                                  <Link to={`edit/admin/${article.id}`}>
                                    <i class="far fa-edit fa-lg"></i>
                                  </Link>
                                  &nbsp;&nbsp;&nbsp;&nbsp;
                                  <a
                                    style={{ color: "red" }}
                                    onClick={() => destroyArticle(article.id)}
                                  >
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                  </a>
                                </td>
                              </tr>
                            );
                          }
                          // )
                        )
                        }
                      </tbody></>

                  }



                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default AdminList;
